import { useEffect, useState } from "react";
import axios from "axios";
import { useSearchParams } from "react-router-dom";
import { useContent } from "../context/ContentContext";
import Navbar from "../components/Navbar";
import { API } from "../context/AuthContext";
import { Gamepad2, Flag } from "lucide-react";
import RallyCard from "../components/RallyCard";
import { rallyStatus } from "../lib/dates";

const FOCUS_LABEL = { QUIZ: "Quiz a tempo", SQUADRA: "Squadra fanta e sfide", MISSIONI: "Missioni sponsor", FANTARALLY: "FantaRally" };

export default function PaddockList({ mode }) {
  const [rallies, setRallies] = useState([]);
  const [params] = useSearchParams();
  const { c } = useContent();
  const focus = mode === "fanta" ? "FANTARALLY" : (params.get("focus") || "").toUpperCase();
  useEffect(() => { axios.get(`${API}/paddock/rallies`).then(({ data }) => setRallies(data)).catch(() => {}); }, []);
  const order = { LIVE: 0, UPCOMING: 1, TBA: 2, FINISHED: 3 };
  const sorted = [...rallies].sort((a, b) => order[rallyStatus(a.start_date, a.end_date).code] - order[rallyStatus(b.start_date, b.end_date).code]);

  return (
    <div className="min-h-screen grain-bg">
      <Navbar />
      <section className="pt-24 md:pt-28 pb-24 max-w-7xl mx-auto px-5 lg:px-8">
        <div className="rl-banner rl-watermark p-6 md:p-12 mb-8 md:mb-10 flex flex-wrap items-center gap-6 md:gap-8" data-testid="paddock-banner">
          <img src="/logo-mark.png" alt="Rally Love" className="w-20 md:w-40 h-auto drop-shadow-[0_0_24px_rgba(255,30,39,0.5)]" />
          <div className="relative flex-1 min-w-[240px]">
            <div className="pill-badge mb-3">{mode === "fanta" ? <><Flag className="w-3 h-3" /> FANTARALLY · SCEGLI IL RALLY</> : <><Gamepad2 className="w-3 h-3" /> RALLY LOVE PADDOCK{focus && FOCUS_LABEL[focus] ? ` · ${FOCUS_LABEL[focus].toUpperCase()}` : ""}</>}</div>
            <h1 className="headline-huge text-4xl sm:text-5xl lg:text-6xl mb-3" data-testid="paddock-list-title">{mode === "fanta" ? "Pronostica come un team manager." : c("paddock.title", "Gioca il tuo rally.")}</h1>
            <p className="text-slate-400 max-w-2xl">{mode === "fanta" ? "Scegli un rally e pronostica vincitore assoluto, podio, prove speciali e classi. Solo punti virtuali: nessuna scommessa, nessuna vincita in denaro." : c("paddock.subtitle", "Quiz a tempo, FANTARALLY, missioni sponsor.")}</p>
          </div>
        </div>
        {rallies.length === 0 && <div className="rl-card p-10 text-center text-slate-500">Nessun rally pubblicato al momento.</div>}
        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {sorted.map((r, i) => <RallyCard key={r.id} r={r} index={i} testid={`paddock-rally-${r.id}`} to={focus ? `/paddock/${r.id}?tab=${focus}` : undefined} />)}
        </div>
        {rallies.some(r => r.demo) && <p className="text-[11px] text-slate-500 mt-8" data-testid="demo-disclaimer">Gli eventi contrassegnati DEMO sono dimostrativi: evento, partecipanti, risultati e sponsor sono completamente fittizi. FANTARALLY utilizza esclusivamente punti virtuali.</p>}
      </section>
    </div>
  );
}
